var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activity',{attrs:{"fonts":_vm.fonts,"message":_vm.liveMessage}},[_c(_vm.currentComponent,{tag:"component",on:{"hook:updated":_vm.focusFirstFocusableElement}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }